import { FC, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import s from './Header.module.scss'

import { useAuthContext } from 'contexts/AppAuthContext'
import { useAppErrorContext } from 'contexts/AppErrorContext'
import { useArcanaContext } from 'contexts/ArcanaAuthContext'
import { useDeviceContext } from 'contexts/DeviceContext'

import { settingsApi } from 'api/settings-api'

import arcanaIcon from 'assets/svg/arcana-logo.png'
import metamaskIcon from 'assets/svg/icons-crypto-metamask.svg'
import { ReactComponent as LoginIcon } from 'assets/svg/icons-login.svg'
import { ReactComponent as LogoutIcon } from 'assets/svg/icons-logout.svg'

import { CustomButton } from 'components/UI/CustomButton/CustomButton'
import MetamaskIsDisabledModal from 'components/modals/MetamaskIsDisabledModal/MetamaskIsDisabledModal'

interface HeaderProps {
  style?: React.CSSProperties
  children?: React.ReactNode
  className?: string
  loading?: boolean
}

const Header: FC<HeaderProps> = (props) => {
  const { children, style, className } = props
  const { deviceWidth } = useDeviceContext()
  const { setAppError } = useAppErrorContext()
  const {
    authData: { web3token, metamaskAcc, arcanaAcc },
    setWeb3Token,
    setMetamaskAcc,
    setArcanaAcc,
  } = useAuthContext()

  const [metamaskIsNotAvailable, setMetamaskIsNotAvailable] = useState(false)

  const navigate = useNavigate()

  const [logoutLoading, setLogoutLoading] = useState(false)

  const webToken = localStorage.getItem('web3token') || ''
  useEffect(() => {
    setWeb3Token(webToken)
  }, [webToken])

  const logout = () => {
    localStorage.removeItem('metamaskAcc')
    setMetamaskAcc('')
    localStorage.removeItem('web3token')
    setWeb3Token('')
    navigate('../marketplace')
  }

  const { logout: arcanaLogout } = useArcanaContext()

  const handleArcanaLogout = async () => {
    localStorage.removeItem('web3token')
    setWeb3Token('')
    localStorage.removeItem('arcanaAcc')
    setArcanaAcc('')
    setLogoutLoading(true)
    try {
      await arcanaLogout()
      setLogoutLoading(false)
    } catch (e) {
      console.error(e)
      setLogoutLoading(false)
    }
    navigate(0)
  }

  // for display of user's subscription type
  const [subType, setSubType] = useState(1)
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const { headers } = await settingsApi.checkSubscription()
        setSubType(+headers.subscription)
      } catch (error: any) {
        setAppError(error)
      }
    }
    if (web3token) {
      fetchSettings()
    }
  }, [])

  return (
    <header className={`${s.headerWrapper} ${className}`} style={style}>
      <div className={s.header}>
        <div className={s.controls}>{children}</div>
      </div>
      {deviceWidth > 600 && (
        <div>
          {!web3token ? (
            <CustomButton
              onClick={() => navigate('/login')}
              variant="outlined"
              className={s.connectButton}
              size={deviceWidth <= 914 ? '40' : '240'}
            >
              {deviceWidth <= 914 ? <LoginIcon style={{ minWidth: '1.5rem', fill: '#fff' }} /> : 'Connect'}
            </CustomButton>
          ) : null}

          <div className={s.buttonsWrapper}>
            {web3token && metamaskAcc && (
              <>
                <CustomButton
                  variant="outlined"
                  style={{ borderColor: subType ? '#fff' : '#fb0943' }}
                  onClick={() => navigate('../settings')}
                  size="240"
                  className={s.disconnectButton}
                >
                  <img className={s.metamaskIcon} src={metamaskIcon} alt="" />
                  {deviceWidth > 914 ? <span className={s.cropTextButton}>{metamaskAcc}</span> : null}
                </CustomButton>
                <CustomButton variant="outlined" onClick={logout} className={s.disconnectButton} size={'240'}>
                  {deviceWidth <= 914 ? (
                    <LogoutIcon stroke="#fff" style={{ minWidth: '1.5rem', width: '1.5rem' }} />
                  ) : (
                    'Disconnect'
                  )}
                </CustomButton>
              </>
            )}
            {web3token && arcanaAcc && (
              <>
                <CustomButton
                  variant="outlined"
                  style={{ borderColor: subType ? '#fff' : '#fb0943' }}
                  onClick={() => navigate('../settings')}
                  size="240"
                  className={s.disconnectButton}
                >
                  <img className={s.metamaskIcon} src={arcanaIcon} alt="" />
                  {deviceWidth > 914 ? <span className={s.cropTextButton}>{arcanaAcc}</span> : null}
                </CustomButton>
                <CustomButton
                  variant="outlined"
                  onClick={handleArcanaLogout}
                  className={`${s.disconnectButton}`}
                  size={'240'}
                  disabled={logoutLoading}
                >
                  {deviceWidth <= 914 ? (
                    <LogoutIcon stroke="#fff" style={{ minWidth: '1.5rem', width: '1.5rem' }} />
                  ) : (
                    'Disconnect'
                  )}
                </CustomButton>
              </>
            )}
          </div>

          {metamaskIsNotAvailable && (
            <MetamaskIsDisabledModal
              onHide={() => {
                setMetamaskIsNotAvailable(false)
              }}
            />
          )}
        </div>
      )}
    </header>
  )
}
export default Header
